import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui/button";

type ModalDowngradeRoleProps = {
  downgradeToMember: () => void;
  closeModal: () => void;
};

export const ModalDowngradeRole = ({
  downgradeToMember,
  closeModal,
}: ModalDowngradeRoleProps) => {
  const { t } = useTranslation();

  function handleDowngrade() {
    downgradeToMember();
    closeModal();
  }

  return (
    <div className="flex h-full flex-col justify-between overflow-hidden">
      <div className="p-10">
        <h2 id="modal-downgrade-role-title" className="mb-4 text-2xl font-bold">
          {t("settings.member_tabs.confirm_remove_access_title")}
        </h2>
        <div className="mb-12 text-sm text-gray-700">
          {t("settings.member_tabs.confirm_remove_access_info")}
        </div>
      </div>
      <footer className="flex shrink-0 justify-end space-x-6 border-t border-gray-100 p-6 md:p-10 md:pt-6">
        <Button
          type="button"
          className="border-none text-green-900"
          variant="outline"
          onClick={closeModal}
        >
          {t("cancel")}
        </Button>{" "}
        <Button type="submit" onClick={handleDowngrade}>
          {t("confirm")}
        </Button>
      </footer>
    </div>
  );
};
